export function hasVsmAccess(features) {
  const f = features || {}
  return !!(
    f.vehicle_status_management_enabled ||
    f.vehicle_status_management_dvir_enabled ||
    f.vehicle_status_management_maint_enabled
  )
}

export function hasVsmHistoryAccess(user) {
  if (!user) return false
  if (user.role === 'garage' || user.role === 'wash-bay') return false
  const features = (user.features && user.features[user.tenant]) || {}
  return !!features.vehicle_status_management_enabled
}

export function vsmRouteName(tenantType, features) {
  if (!hasVsmAccess(features)) return 'vehstatusmgr'

  const f = features || {}
  if (tenantType === 'TBN') {
    if (f.vehicle_status_management_dvir_enabled) return 'vehicle_status_dvir_tbn'
    if (f.vehicle_status_management_maint_enabled) return 'vehicle_status_maint_tbn'
    return 'vehicle_status_tbn'
  }
  if (f.vehicle_status_management_maint_enabled) return 'vehicle_status_maint'
  if (f.vehicle_status_management_dvir_enabled) return 'vehicle_status_dvir'
  return 'vehicle_status'
}
